import React from 'react';
import {
  RiFileExcelLine,
  RiFileLine,
  RiFilePdf2Line,
  RiFileTextLine,
  RiImageLine,
} from 'react-icons/ri';

interface FileIconContainerProps {
  fileName: string;
  color?: string;
  size?: number;
}

const FileIconContainer: React.FC<FileIconContainerProps> = ({
  fileName,
  color = '#6b7280',
  size = 20,
}) => {
  const getFileIcon = (): React.ReactElement => {
    const extension = fileName.split('.').pop()?.toLowerCase() ?? '';
    const iconProps = {
      size,
      color,
    };

    // PDF files
    if (extension === 'pdf') {
      return <RiFilePdf2Line {...iconProps} />;
    }

    // Document files (DOC, DOCX)
    if (['doc', 'docx'].includes(extension)) {
      return <RiFileTextLine {...iconProps} />;
    }

    // Image files (JPEG, PNG, GIF, WebP)
    if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(extension)) {
      return <RiImageLine {...iconProps} />;
    }

    // Spreadsheet files (XLS, XLSX)
    if (['xls', 'xlsx'].includes(extension)) {
      return <RiFileExcelLine {...iconProps} />;
    }

    // Default file icon for unsupported formats
    return <RiFileLine {...iconProps} />;
  };

  return (
    <div
      className="flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      {getFileIcon()}
    </div>
  );
};

export default FileIconContainer;
